"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useXGridStyles = void 0;
const makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
const constants_1 = require("./constants");
exports.useXGridStyles = {
    [constants_1.XGridTableStyle.PRIMARY]: makeStyles_1.default((theme) => ({
        root: {
            minHeight: '35rem',
            background: theme.palette.common.white,
            marginBottom: '1.5rem',
            marginTop: '1.5rem',
            color: theme.palette.black.main,
            '& .MuiDataGrid-columnsContainer': {
                maxHeight: 'none !important',
            },
            '& .MuiDataGrid-columnHeaderWrapper': {
                background: theme.palette.common.white,
                borderTop: '0.063rem solid',
                borderTopColor: theme.palette.black['600'],
            },
            '& .MuiDataGrid-columnHeader': {
                borderTop: `0.063rem solid ${theme.palette.common.white}`,
                borderBottom: `0.063rem solid ${theme.palette.common.white}`,
            },
            '& .MuiDataGrid-iconSeparator': {
                color: theme.palette.black['600'],
            },
            '& .Mui-selected': {
                backgroundColor: 'transparent !important',
            },
            '& .MuiDataGrid-row': {
                position: 'relative',
                border: `0.063rem solid transparent`,
            },
            '& .MuiDataGrid-row:hover': {
                backgroundColor: `${theme.palette.primary['600']} !important`,
                borderColor: theme.palette.primary['500'],
            },
            '& .MuiDataGrid-columnHeader:focus-within, .MuiDataGrid-cell:focus-within': {
                outline: 'none',
            },
            '& .MuiDataGrid-columnHeader--sorted': {
                borderTopColor: `${theme.palette.primary.main}`,
                borderBottomColor: `${theme.palette.primary.main}`,
                color: theme.palette.primary.main,
                '& .MuiIconButton-root': {
                    color: theme.palette.primary.main,
                },
            },
            '& .MuiDataGrid-sortIcon': {
                fontSize: '1rem',
            },
        },
    })),
    [constants_1.XGridTableStyle.SECONDARY]: makeStyles_1.default((theme) => ({
        root: {
            minHeight: '35rem',
            background: 'none',
            marginBottom: '1.5rem',
            marginTop: '1.5rem',
            color: theme.palette.black.main,
            '& .MuiDataGrid-columnsContainer': {
                maxHeight: 'none !important',
            },
            '& .MuiDataGrid-columnHeaderWrapper': {
                background: 'none',
                borderTop: '0.063rem solid',
                borderBottom: '0.063rem solid',
                borderTopColor: theme.palette.black['600'],
                borderBottomColor: theme.palette.black['600'],
            },
            '& .MuiDataGrid-iconSeparator': {
                color: 'none',
            },
            '& .Mui-selected': {
                backgroundColor: 'transparent !important',
            },
            '& .MuiDataGrid-row:hover': {
                backgroundColor: `transparent`,
            },
            '& .MuiDataGrid-columnHeader:focus-within, .MuiDataGrid-cell:focus-within': {
                outline: 'none',
            },
            '& .MuiDataGrid-columnHeader--sorted': {
                borderTop: '0.063rem solid',
                borderTopColor: theme.palette.primary.main,
                borderBottom: '0.063rem solid',
                borderBottomColor: theme.palette.primary.main,
                color: theme.palette.primary.main,
                '& .MuiIconButton-root': {
                    color: theme.palette.primary.main,
                },
            },
            '& .MuiDataGrid-sortIcon': {
                fontSize: '1rem',
            },
        },
    })),
    [constants_1.XGridTableStyle.TERTIARY]: makeStyles_1.default((theme) => ({
        root: {
            background: 'none',
            color: theme.palette.black.main,
            '& .MuiDataGrid-columnsContainer': {
                maxHeight: 'none !important',
            },
            '& .MuiDataGrid-columnHeaderWrapper': {
                background: theme.palette.offWhite,
                borderTop: '0.063rem solid',
                borderTopColor: theme.palette.black['600'],
            },
            '& .MuiDataGrid-columnHeader': {
                borderTop: `0.063rem solid ${theme.palette.common.white}`,
                borderBottom: `0.063rem solid ${theme.palette.common.white}`,
                boxShadow: `inset -0.0625rem 0 0 ${theme.palette.black['500']}, 
        inset 0 -0.0625rem 0 ${theme.palette.black['500']}`,
            },
            '& .MuiDataGrid-iconSeparator': {
                color: 'transparent',
            },
            '& .Mui-selected': {
                backgroundColor: `${theme.palette.primary['600']} !important`,
            },
            '& .MuiDataGrid-row': {
                position: 'relative',
                border: `0.063rem solid transparent`,
            },
            '& .MuiDataGrid-row:hover': {
                backgroundColor: `${theme.palette.primary['600']} !important`,
                borderColor: theme.palette.primary['500'],
            },
            '& .MuiDataGrid-columnHeader:focus-within, .MuiDataGrid-cell:focus-within': {
                outline: 'none',
            },
            '& .MuiDataGrid-columnHeader--sorted': {
                borderTopColor: `${theme.palette.primary.main}`,
                borderBottomColor: `${theme.palette.primary.main}`,
                color: theme.palette.primary.main,
                '& .MuiIconButton-root': {
                    color: theme.palette.primary.main,
                },
            },
            '& .MuiDataGrid-sortIcon': {
                fontSize: '1rem',
            },
        },
    })),
    [constants_1.XGridTableStyle.QUATERNARY]: makeStyles_1.default((theme) => ({
        root: {
            background: 'none',
            color: theme.palette.black.main,
            '& .MuiDataGrid-columnsContainer': {
                maxHeight: 'none !important',
            },
            '& .MuiDataGrid-columnHeaderWrapper': {
                background: theme.palette.offWhite,
                borderTop: '0.063rem solid',
                borderTopColor: theme.palette.black['600'],
            },
            '& .MuiDataGrid-columnHeader': {
                borderTop: `0.063rem solid ${theme.palette.common.white}`,
                borderBottom: `0.063rem solid ${theme.palette.common.white}`,
            },
            '& .MuiDataGrid-iconSeparator': {
                color: theme.palette.black['600'],
            },
            '& .Mui-selected': {
                backgroundColor: `${theme.palette.primary['600']} !important`,
            },
            '& .MuiDataGrid-row': {
                background: '#FFFFFF',
                boxShadow: `inset 0px -1px 0px ${theme.palette.black['600']}`,
                position: 'relative',
                border: `0.063rem solid transparent`,
            },
            '& .MuiDataGrid-cell': {
                borderBottom: 0,
            },
            '& .MuiDataGrid-row:hover': {
                backgroundColor: `${theme.palette.primary['600']} !important`,
                borderColor: theme.palette.primary['500'],
            },
            '& .MuiDataGrid-columnHeader:focus-within, .MuiDataGrid-cell:focus-within': {
                outline: 'none',
            },
            '& .MuiDataGrid-cell.MuiDataGrid-cell--editing:focus-within': {
                outline: 'none',
            },
            '& .MuiDataGrid-cell.MuiDataGrid-cell--editing': {
                boxShadow: 'none',
                alignItems: 'center',
                backgroundColor: 'transparent',
            },
            '& .MuiDataGrid-columnHeader--sorted': {
                borderTopColor: `${theme.palette.primary.main}`,
                borderBottomColor: `${theme.palette.primary.main}`,
                color: theme.palette.primary.main,
                '& .MuiIconButton-root': {
                    color: theme.palette.primary.main,
                },
            },
            '& .MuiDataGrid-sortIcon': {
                fontSize: '1rem',
            },
        },
    })),
};
//# sourceMappingURL=data:application/json;base64,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